<template>
  <div class="moow-master-container">
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <div v-else class="container">
      <b-row class="mt-5">
        <b-col lg="2" md="2" sm="1"></b-col>
        <b-col lg="9" md="10" sm="11">
          <md-card class="island-card pr-3">
            <md-card-content>
              <md-tabs :md-active-tab="activeTab">
                <!-- GENERAL -->
                <md-tab id="tab-contact" :md-label="i18n_local.ui.account.general">
                  <h3 class="moow-subheader">{{i18n_local.org_details}}</h3>
                  <span class="moow-info-txt secondary">{{i18n_local.info_account_org}}</span>
                  <info-toggle :infoContent="i18n_local.info_about_account" size="small" />

                  <md-progress-bar v-if="loadingAccount" md-mode="indeterminate"></md-progress-bar>
                  <div v-else>
                    <md-field :class="{ 'md-invalid': contactEmailErr }">
                      <label>{{i18n_local.emailNotif}}</label>
                      <md-input v-model="contactEmail"></md-input>
                      <span class="md-error">Required field</span>
                    </md-field>
                    <md-field :class="{ 'md-invalid': contactPhoneErr }">
                      <label>{{i18n_local.phone}}</label>
                      <md-input v-model="contactPhone"></md-input>
                      <span class="md-error">Required field</span>
                    </md-field>
                    <md-field :class="{ 'md-invalid': accountNameErr }">
                      <label>{{i18n_local.ui.account.accountName}}</label>
                      <md-input v-model="accountName"></md-input>
                      <span class="md-error">Required field</span>
                    </md-field>
                    <md-field>
                      <label>{{i18n_local.your_role}}</label>
                      <md-input v-model="currentUserRole" readonly disabled></md-input>
                    </md-field>
                    <md-field>
                      <label>{{i18n_local.accountId}}</label>
                      <md-input v-model="accountId" readonly disabled></md-input>
                    </md-field>
                    <b-row>
                      <div>
                        <moow-button
                          :type="['light']"
                          btnText="Save"
                          @mClick="saveContactDetails"
                          :disabled="contactFieldsSaved || currentUserRole !='admin'"
                        />
                      </div>
                    </b-row>
                  </div>
                </md-tab>
                <md-tab
                  id="tab-invites"
                  :md-label="i18n_local.ui.account.access"
                  :md-disabled="currentUserRole!='admin'"
                >
                  <b-row>
                    <b-col cols="9">
                      <p class="moow-header">{{i18n_local.user_access}}</p>
                      <span class="moow-info-txt secondary">{{i18n_local.info_user_access}}</span>
                    </b-col>
                    <b-col cols="3">
                      <div class="moow-header">
                        <md-button
                          class="md-icon-button md-dense md-raised md-primary"
                          @click="refreshInvites()"
                        >
                          <md-icon>cached</md-icon>
                        </md-button>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <user-invites ref="userInviteRef" />
                    </b-col>
                  </b-row>
                </md-tab>
                <!-- IDENTITY -->
                <md-tab id="tab-identity" :md-label="i18n_local.ui.account.identity">
                  <div v-if="!currentUserPrivPerson">
                    <p class="moow-subheader">{{i18n_local.info.add_your_identity}}</p>
                    <private-person-search ref="privPersonSearchRef" @emitShowSaveIdent="showSaveIdentButton"></private-person-search>
                    <moow-button :type="['light']" btnText="Save" @mClick="saveIdentity" v-if="showSaveIdent"/>
                  </div>
                  <md-progress-bar
                    md-mode="indeterminate"
                    v-else-if="currentUserPrivPerson=='loading'"
                  ></md-progress-bar>
                  <div v-else>
                    <p class="moow-subheader">{{i18n_local.info.my_identity}}</p>
                    <md-field v-if="currentUserPrivPerson.idCode">
                      <label>Person Idendification Code</label>
                      <md-input v-model="currentUserPrivPerson.idCode" readonly></md-input>
                    </md-field>
                    <md-field v-else>
                      <label>Social Security or tax number</label>
                      <md-input v-model="currentUserPrivPerson.ssnTaxNr" readonly></md-input>
                    </md-field>
                    <md-field>
                      <label>Full Name</label>
                      <md-input v-model="currentUserPrivPerson_name" readonly></md-input>
                    </md-field>
                    <md-field>
                      <label>Date of Birth</label>
                      <md-input v-model="currentUserPrivPerson_dob" readonly></md-input>
                    </md-field>
                    <moow-button
                      v-if="currentUserRole=='admin'"
                      :type="['light', 'outlined']"
                      btnText="Edit"
                      @mClick="editIdentity"
                    />
                    <br>
                            <md-divider class="moow-divider"></md-divider>

                    <b-row class="mt-5">
                      <b-col>
                        <p class="moow-subheader">{{i18n_local.info.add_document}}</p>
                        <user-private-files
                            :account-id="selectedAccountId"
                        ></user-private-files>
                      </b-col>
                    </b-row>
                  </div>
                  
                </md-tab>

                <!-- COMPANY -->
                <md-tab id="tab-company" :md-label="i18n_local.ui.account.company">
                  <div v-if="!currentUserPrivPerson._id">
                    <p class="moow-subheader">{{i18n_local.specify_id_first}}</p>
                  </div>
                  <div v-else-if="currentUserJurPersons.length == 0">
                    <b-row>
                      <b-col>
                        <p class="moow-subheader">{{i18n_local.info.add_company_identity}}</p>
                        <p
                          class="moow-info-txt"
                        >{{i18n_local.info.will_be_used_in_future}}.</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <jur-person-search ref="jurPersonSearchRef" @emitShowSaveIdent="showSaveCompIdentButton"></jur-person-search>
                        <moow-button :type="['light']" btnText="Save" @mClick="saveCompany" v-if="showSaveCompIdent"/>
                      </b-col>
                    </b-row>
                  </div>

                  <div v-else>
                    <p class="moow-subheader">{{i18n_local.info.my_company}}</p>
                    <b-row>
                      <b-col
                        class="mb-1"
                        v-for="(jurPerson, index) in currentUserJurPersons"
                        :key="jurPerson._id+index"
                      >
                        <md-progress-bar md-mode="indeterminate" v-if="jurPerson.state=='loading'"></md-progress-bar>
                        <div v-else>
                          <md-field>
                            <label>Name</label>
                            <md-input v-model="jurPerson.name" readonly></md-input>
                          </md-field>
                          <md-field>
                            <label>Reg Nr</label>
                            <md-input v-model="jurPerson.regNr" readonly></md-input>
                          </md-field>
                          <md-field v-if="jurPerson.vatNr">
                            <label>VAT Nr</label>
                            <md-input v-model="jurPerson.vatNr" readonly></md-input>
                          </md-field>
                          <md-field>
                            <label>Email</label>
                            <md-input v-model="jurPerson.emails[0]" readonly></md-input>
                          </md-field>
                          <md-field>
                            <label>Address</label>
                            <md-input v-model="jurPerson.addresses[0]" readonly></md-input>
                          </md-field>
                          <md-field>
                            <label>Registration Country</label>
                            <md-input v-model="jurPerson.regCountry" readonly></md-input>
                          </md-field>
                        </div>

                        <!-- {{jurPerson}} -->
                        <!-- <md-card class="island-card pr-3">
                          
                          <md-card-content v-else>
                            
                          </md-card-content>
                        </md-card>-->
                      </b-col>
                    </b-row>
                  </div>
                </md-tab>

                <!-- PAYMENTS -->
                <md-tab
                  id="tab-payment"
                  :md-label="i18n_local.ui.account.payments"
                  :md-disabled="currentUserRole!='admin'"
                >
                  <h3 class="moow-header">{{i18n_local.bank_account_info}}</h3>
                  <!-- {{accountDetails}} -->
                  <p class="moow-info-txt">{{i18n_local.bank_account_info_desc}}</p>
                  <md-progress-bar v-if="loadingAccount" md-mode="indeterminate"></md-progress-bar>

                  <div v-else>
                    <h3 class="moow-subheader">Account holder name</h3>
                    <md-field :class="{ 'md-invalid': accountHolderErr }">
                      <md-input
                        v-model="accountHolderName"
                        :placeholder="accountHolderNamePlaceholder"
                        required
                      ></md-input>
                      <span class="md-error">Required field</span>
                    </md-field>

                    <h3 class="moow-subheader">Bank name</h3>
                    <md-field :class="{ 'md-invalid': bankNameErr }">
                      <md-input v-model="bankName" :placeholder="bankNamePlaceholder" required></md-input>
                      <span class="md-error">Required field</span>
                    </md-field>

                    <h3 class="moow-subheader">SWIFT / BIC ID</h3>
                    <md-field :class="{ 'md-invalid': swiftErr }">
                      <md-input v-model="swiftCode" :placeholder="swiftCodePlaceholder" required></md-input>
                      <span class="md-error">Required field</span>
                    </md-field>

                    <h3 class="moow-subheader">IBAN</h3>
                    <md-field :class="{ 'md-invalid': ibanErr }">
                      <md-input v-model="ibanCode" :placeholder="ibanCodePlaceholder" required></md-input>
                      <span class="md-error">{{ibanErrMsg}}</span>
                    </md-field>

                    <h3 class="moow-subheader">Confirm IBAN</h3>
                    <md-field :class="{ 'md-invalid': ibanNotMatchErr }">
                      <md-input v-model="ibanCodeConfirm" required></md-input>
                      <span class="md-error">Doesn't match</span>
                    </md-field>

                    <b-row>
                      <div>
                        <moow-button :type="['light']" btnText="Save" @mClick="savePaymentDetails" />
                      </div>
                    </b-row>
                  </div>
                </md-tab>
              </md-tabs>
            </md-card-content>
          </md-card>
        </b-col>
        <b-col lg="2" md="2" sm="1"></b-col>
      </b-row>
    </div>

    <moow-dialog-confirm
      :title="i18n_local.tc.confirmIdentityTitle"
      :content="i18n_local.tc.confirmIdentityContent"
      :confirmText="i18n_local.continue"
      :cancelText="i18n_local.cancel"
      :showDialog="confirmationDialog"
      @mConfirm="onConfirmPrivPersonSave"
      @mCancel="onCancelConfirmation"
    />

    <moow-dialog-confirm
      :title="i18n_local.tc.confirmCompanyTitle"
      :content="i18n_local.tc.confirmCompanyContent"
      :confirmText="i18n_local.continue"
      :cancelText="i18n_local.cancel"
      :showDialog="showJurPersonConfirmDialog"
      @mConfirm="onConfirmJurPersonSave"
      @mCancel="onCancelConfirmation"
    />

    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>
  </div>
</template>
<script>
import {
  getUserUid,
  updateCurrentUserRootLevelKeys,
  updateUserCompanyDetails,
} from "../users/repositories/userRepository.js";
import { getCurrentUser } from "../users/services/userService.js";

import PrivatePersonSearch from "@/components/person/privatePersonSearch.vue";
import JuridicalPersonSearch from "@/components/person/juridicalPersonSearch.vue";
import { formatDateToString } from "@/timeFunctions.js";
import Snackbar from "./snackbar.vue";
import { updateUser } from "../users/services/userService.js";
import { getCurrentUserUid,getCurrentFirebaseUser } from "@/platform/auth/services/authService.js";
import {
  addPrivPersonToAccount,
  addJurPersonToAccount,
} from "@/platform/account/services/accountService.js";
var lodash = require("lodash/function");
import { createHelpers } from "vuex-map-fields";
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";
import UserInvites from "@/components/account/UserInvites.vue";
import UserPrivateFiles from "@/components/UserPrivateFiles.vue";
import { mapGetters } from "vuex";

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: "getAccountPaymentDetails",
  mutationType: "updateAccountPaymentDetails",
});
const { mapFields: mapContactFields } = createHelpers({
  getterType: "getAccountContactDetails",
  mutationType: "updateAccountContactDetails",
});
const { mapFields: mapDetailsFields } = createHelpers({
  getterType: "getAccountDetails",
  mutationType: "updateAccountDetails",
});

export default {
  name: "account",
  components: {
    "error-snackbar": Snackbar,
    "private-person-search": PrivatePersonSearch,
    "jur-person-search": JuridicalPersonSearch,
    "info-toggle": InfoToggle,
    "user-invites": UserInvites,
    UserPrivateFiles,
  },
  props: {
    openWithTab: {
      type: String,
      required: false,
    },
    postSaveRedirect: {
      type: String,
      required: false,
    },
    // TODO: hide this into a single abstract redirect package
    chatRoomId: {
      type: String,
      required: false,
    },
    bookingRequest: {
      type: Object,
      required: false,
    },
    returnToDealId: {
      type: String,
      required: false,
    },
    ownerViewing: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      selectedCompany: "",
      repType: "",
      repTypeErr: false,
      showJurPersonConfirmDialog: false,
      confirmationDialog: false,
      useCompanyByDefault: false,
      activeTab: "tab-contact",
      loading: false,
      accountHolderNamePlaceholder: "",
      swiftCodePlaceholder: "Ex. AAAAAUS3N",
      ibanCodeConfirm: "",
      idCode: "",
      ibanCodePlaceholder: "Ex. DE55554444333322221111",
      bankNamePlaceholder: "Ex. Swedbank",
      snackbarMessage: "",
      showSnackbar: false,
      accountHolderErr: false,
      bankNameErr: false,
      contactPhoneErr: false,
      contactEmailErr: false,
      accountNameErr: false,
      swiftErr: false,
      ibanErr: false,
      idCodeErr: false,
      ibanNotMatchErr: false,
      ibanErrMsg: "Required field",
      userUid: "",
      contractDetailsEdited: true,
      companyDetailsEdited: true,
      companyName: "",
      companyRegNr: "",
      companyVatNr: "",
      companyAddress: "",
      companyEmail: "",
      contactFieldsSaved: false,
      rules: {
        emailRule: /.+@.+/,
      },
      showSaveIdent: false,
      showSaveCompIdent: false
    };
  },
  watch: {
    accountName: function (val) {
      this.contactFieldsSaved = false;
      if (val) this.accountNameErr = false;
      else this.accountNameErr = true;
    },
    contactEmail: function (val) {
      this.contactFieldsSaved = false;
      if (val && this.rules.emailRule.test(val)) this.contactEmailErr = false;
      else this.contactEmailErr = true;
    },
    contactPhone: function (val) {
      this.contactFieldsSaved = false;
      if (!val) this.contactPhoneErr = false;
      else this.contactPhoneErr = false;
    },
    ibanCodeConfirm: function (val) {
      if (val && this.ibanCode != val) this.ibanNotMatchErr = true;
      else this.ibanNotMatchErr = false;
    },
    idCode: function (val) {
      if (!val || val.length < 5) this.idCodeErr = true;
      else this.idCodeErr = false;
      this.contractDetailsEdited = true;
    },
    companyName: function (val) {
      this.companyDetailsEdited = true;
    },
    companyEmail: function (val) {
      this.companyDetailsEdited = true;
    },
    companyVatNr: function (val) {
      this.companyDetailsEdited = true;
    },
    companyAddress: function (val) {
      this.companyDetailsEdited = true;
    },
    companyRegNr: function (val) {
      this.companyDetailsEdited = true;
    },
    useCompanyByDefault: function (val) {
      this.companyDetailsEdited = true;
    },
    selectedAccountId: function (val, oldVal) {
      this.accountSelectionWasMade(val, oldVal);
    },
  },
  async created() {
    this.$emit("emitChangeViewTitle", "My Organization");
    if (this.openWithTab) {
      this.changeTab(this.openWithTab);
    }
    this.loading = true;
    this.selectedAccountId
      ? this.$store.dispatch("getAccount", this.selectedAccountId)
      : void 0;

    let user = getCurrentFirebaseUser()
    if (user && !user.isAnonymous) {
      this.accountHolderNamePlaceholder = "Ex. " + user.displayName;
      this.userUid = user.uid;
      const cUser = await getCurrentUser(user.uid)
      if(!cUser) {
          this.loading = false;
          this.notifyUser("Cannot get payment details");
      }else {
          this.bindPersonalDetails(cUser);
          this.bindCompanyDetails(cUser.companyDetails);
          this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    ...mapDetailsFields(["accountName"]),
    ...mapContactFields(["contactEmail", "contactPhone"]),
    ...mapPaymentFields([
      "accountHolderName",
      "bankName",
      "swiftCode",
      "ibanCode",
    ]),
    currentUserRole() {
      return this.$store.getters.userRoleInAccount;
      // return "viewer";
    },
    accountId() {
      return this.$store.getters.accountDetails.accountId;
    },
    loadingAccount() {
      return this.$store.getters.loadingAccount;
    },
    selectedAccountId() {
      if (this.$store.getters.connectedAccountIds.length > 0)
        return this.$store.getters.connectedAccountIds[0];
      return null;
    },
    currentUserPrivPerson_dob() {
      if (this.currentUserPrivPerson.dob)
        return formatDateToString(this.currentUserPrivPerson.dob, "YYYY/MM/DD");
      else return "";
    },
    currentUserPrivPerson_name() {
      if (this.currentUserPrivPerson.givenName) {
        return (
          this.capitalize(this.currentUserPrivPerson.givenName) +
          " " +
          this.capitalize(this.currentUserPrivPerson.surname)
        );
      } else return "";
    },
    currentUserPrivPerson() {
      var p = this.$store.getters.privatePerson;
      if (!p || Object.keys(p).length == 0) return false;
      else if (p && p.state == "loading") return "loading";
      else return p;
    },
    currentUserJurPersons() {
      return this.$store.getters.jurPersons;
    },
    loaderIcon() {
      return require("../assets/loader-rolling.svg");
    },
    defaultConnectedAccountId() {
      return this.$store.getters.connectedAccountIds[0];
    },
  },
  methods: {
    showSaveIdentButton(value){
      this.showSaveIdent = value
    },
    showSaveCompIdentButton(value){
      this.showSaveCompIdent = value
    },
    accountSelectionWasMade: lodash.throttle(function (
      newAccountId,
      oldAccountId
    ) {
      if (newAccountId != oldAccountId) {
        this.$store.dispatch("getAccount", newAccountId);
      }
    },
    1000),
    refreshInvites() {
      this.$refs.userInviteRef.refreshInvites();
    },
    editIdentity() {
      this.notifyUser("Contact customer support");
    },
    getJurPersonName(jurPerson) {
      if (jurPerson && jurPerson.name) return this.capitalize(jurPerson.name);
      else return "";
    },
    clearCompany() {
      this.$store.commit("RESET_USER_JUR_PERSONS");
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    saveIdentity() {
      if (this.$refs.privPersonSearchRef.getValidPerson())
        this.confirmationDialog = true;
    },
    saveCompany() {
      if (this.$refs.jurPersonSearchRef.getValidPerson())
        this.showJurPersonConfirmDialog = true;
    },
    onCancelConfirmation() {
      this.confirmationDialog = false;
      this.showJurPersonConfirmDialog = false;
    },
    onConfirmJurPersonSave() {
      this.addJurPersonIdentity();
      this.showJurPersonConfirmDialog = false;
    },
    async onConfirmPrivPersonSave() {
      this.confirmationDialog = false;
      await this.addPrivatePersonIdentity();
      this.redirectBack();
    },
    redirectBack() {
      if (this.postSaveRedirect == "chat") {
        this.redirectTo({
          where: this.postSaveRedirect,
          query: { roomId: this.chatRoomId },
          params: { bookingRequest: this.bookingRequest }
        });
      } else if (this.postSaveRedirect == "deal" && this.returnToDealId) {
        this.redirectTo({
          where: this.postSaveRedirect,
          params: {
            dealId: this.returnToDealId,
            ownerViewingForced: this.ownerViewing,
          },
        });
      } else if (this.postSaveRedirect == "dashboard") {
        this.redirectTo({
          where: this.postSaveRedirect,
          params: { openWithTab: 'tab-draft' }
        });
      }
    },
    addJurPersonIdentity() {
      var validPerson = this.$refs.jurPersonSearchRef.getValidPerson();
      var privPersonId = this.$store.getters.privatePerson._id;
      if (validPerson && privPersonId) {
        this.loading = true;
        addJurPersonToAccount({
          person: validPerson,
          privPersonId: privPersonId,
          accountId: this.defaultConnectedAccountId,
        })
          .then((resp) => {
            if (this.$store.getters.privatePerson._id)
              this.$store.dispatch("setAccountJuridicalPerson", resp.personId);
          })
          .catch((err) => {
            console.log("Account | addJurPersonIdentity > err:", err);
          })
          .finally((r) => {
            this.loading = false;
          });
      }
    },
    async addPrivatePersonIdentity() {
      var validPerson = this.$refs.privPersonSearchRef.getValidPerson();
      if (validPerson) {
        this.loading = true;
        var uid = getCurrentUserUid();
        if (uid) {
          addPrivPersonToAccount({
            accountId: this.defaultConnectedAccountId,
            person: validPerson,
          })
            .then((resp) => {
              this.$store.dispatch("setAccountPrivatePerson", resp.personId);
            })
            .catch((err) => {})
            .finally((r) => {
              this.loading = false;
              return;
            });
        }
      }
    },
    changeTab(tabId) {
      var self = this; // <-- declare self
      self.activeTab = tabId;
    },
    bindPersonalDetails(user) {
      this.idCode = user.idCode;
    },
    bindCompanyDetails(companyDetails) {
      if (companyDetails) {
        this.useCompanyByDefault = companyDetails.representByDefault;
        this.companyName = companyDetails.name;
        this.companyEmail = companyDetails.email;
        this.companyAddress = companyDetails.address;
        this.companyRegNr = companyDetails.regNr;
        this.companyVatNr = companyDetails.vatNr;
      }
    },
    saveContactDetails() {
      if (this.validateContactFields()) {
        this.contactFieldsSaved = true;
        this.notifyUser("Contact details updated");
        this.$store.dispatch("updateAccount", {
          accountId: this.selectedAccountId,
          updates: {
            contactDetails: this.makeContactDetailsUpdateCommand(),
            name: this.accountName,
          },
        });
        this.redirectBack();
      }
    },
    savePaymentDetails() {
      if (this.validateFields()) {
        this.notifyUser("Payment details updated");
        this.$store.dispatch("updateAccount", {
          accountId: this.selectedAccountId,
          updates: { paymentDetails: this.makePaymentDetailsUpdateCommand() },
        });
        this.redirectBack();
      }
    },
    saveCompanyDetails() {
      var companyDet = {
        name: this.companyName,
        regNr: this.companyRegNr,
        vatNr: this.companyVatNr,
        address: this.companyAddress,
        email: this.companyEmail,
      };
      if (this.validateCompanyDetails(companyDet)) {
        this.companyDetailsEdited = false;
        companyDet.representByDefault = this.useCompanyByDefault;
        updateUserCompanyDetails(this.userUid, companyDet)
          .then((response) => {})
          .catch((err) => {
            this.notifyUser("Cannot update, try again later");
          });
      } else this.notifyUser("Specify all company details");
    },
    validateCompanyDetails(compDet) {
      var result = true;
      for (var i in compDet) {
        if (!compDet[i]) {
          // all fields are required
          result = false;
          break;
        }
      }
      return result;
    },
    updateUser(userUpdatesRootLevel) {
      updateCurrentUserRootLevelKeys(userUpdatesRootLevel);
      updateUser(getUserUid(), userUpdatesRootLevel);
      this.notifyUser("Settings updated");
    },
    validateContactFields() {
      if (!this.accountName) {
        this.accountNameErr = true;
        return false;
      } else this.accountNameErr = false;

      if (!this.contactEmail || !this.rules.emailRule.test(this.contactEmail)) {
        this.contactEmailErr = true;
        return false;
      } else this.contactEmailErr = false;

      if (!this.contactPhone) {
        this.contactPhoneErr = true;
        return false;
      } else this.contactPhoneErr = false;

      return true;
    },
    validateFields() {
      !this.accountHolderName
        ? (this.accountHolderErr = true)
        : (this.accountHolderErr = false);
      !this.bankName ? (this.bankNameErr = true) : (this.bankNameErr = false);
      !this.ibanCodeConfirm ? (this.ibanNotMatchErr = true) : void 0;
      if (this.validSwift(this.swiftCode)) this.swiftErr = false;
      else this.swiftErr = true;

      var ibanValidation = this.validIban(this.ibanCode);
      if (ibanValidation.result) this.ibanErr = false;
      else {
        this.ibanErrMsg = ibanValidation.msg;
        this.ibanErr = true;
      }

      if (
        this.accountHolderErr ||
        this.bankNameErr ||
        this.swiftErr ||
        this.ibanErr ||
        this.ibanNotMatchErr
      )
        return false;
      return true;
    },
    validSwift(checkMe) {
      if (checkMe) return true;
      return false;
    },
    validIban(checkMe) {
      if (!checkMe) return { result: false, msg: "Missing" };

      if (checkMe.length < 15) return { result: false, msg: "Too short" };

      if (checkMe.length > 40) return { result: false, msg: "Too long" };

      return { result: true };
    },
    makePaymentDetailsUpdateCommand() {
      if (this.validateFields()) {
        return {
          accountHolderName: this.accountHolderName,
          bankName: this.bankName,
          swiftCode: this.swiftCode,
          ibanCode: this.ibanCode,
        };
      } else {
        this.notifyUser("Specify required details!");
      }
    },
    makeContactDetailsUpdateCommand() {
      if (this.validateContactFields()) {
        return {
          contactEmail: this.contactEmail,
          contactPhone: this.contactPhone,
        };
      } else {
        this.notifyUser("Specify required details!");
      }
    },
    notifyUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    },
    redirectTo({ where, params, query }) {
      this.$router.push({
        name: where,
        params: params,
        query: query,
      });
    },
  },
};
</script>
<style>
@import "../assets/styles/global.css";

/* .el-upload--picture-card {
    border-radius: 100px
  }
.el-icon-delete{
    display: none
} */

.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader .el-upload:hover .avatar-overhover {
  display: inline;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  border-radius: 150px;
  width: 150px;
  height: 150px;
  /* display: block; */
}
.avatar-overhover {
  display: none;
  position: absolute;
  background-color: rgb(255, 255, 255, 0.6);
}

.change-avatar-peek {
  position: absolute;
  z-index: 9999;
  top: 45%;
  left: 43%;
}
</style>



// WEBPACK FOOTER //
// src/components/Account.vue